import * as React from 'react'
import { IHotspot, ISelectOption, IServiceDesignatedHotspot, IServiceObject } from '../../../types/index'
import { IServiceProgramObject } from '../../../types/service-program'
import UIMessages from 'src/utils/ui-messages'
import Select from 'react-select'
import ErrorBar from 'src/components/ui/ErrorBar'

interface IServiceViewDesignatedHotspotsProps {
  serviceId: string
  service?: IServiceObject
  serviceProgram?: IServiceProgramObject
  fetchingError: string
  designatedHotspotLocations: any[]
  designatedHotspotsEnabled: number
  getHotspotsList: (serviceId: string) => Promise<void>
}

interface IState {
  locations: IServiceDesignatedHotspot[]
  selectedHotspotZone: string
  error: {
    message: string
    updatedAt: number
  }
}

class ServiceViewDesignatedHotspot extends React.Component<IServiceViewDesignatedHotspotsProps, IState> {
  constructor(props: IServiceViewDesignatedHotspotsProps) {
    super(props)
    this.state = {
      locations: this.props.designatedHotspotLocations,
      selectedHotspotZone: '',
      error: {
        message: '',
        updatedAt: Date.now()
      }
    }
  }

  public componentDidMount() {
    this.props.getHotspotsList(this.props.serviceId!)
    const { designatedHotspotsEnabled } = this.props
    if (designatedHotspotsEnabled !== undefined && !designatedHotspotsEnabled) {
      this.setState({
        error: {
          message: 'Designated hotspots is disabled for this service.',
          updatedAt: Date.now()
        }
      })
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<IServiceViewDesignatedHotspotsProps>,
    prevState: Readonly<IState>
  ): void {
    if (prevState.error.message !== this.state.error.message) {
      this.setState({
        error: {
          message: '',
          updatedAt: Date.now()
        }
      })
    }

    if (
      JSON.stringify(this.props.designatedHotspotLocations) !== JSON.stringify(this.state.locations) &&
      this.state.locations.length <= 0
    ) {
      this.setState({
        locations: prevProps.designatedHotspotLocations,
        selectedHotspotZone:
          this.props.designatedHotspotLocations.length > 0 ? this.props.designatedHotspotLocations[0].id : ''
      })
    }
  }

  public componentWillUnmount() {
    this.setState({
      error: {
        message: '',
        updatedAt: Date.now()
      }
    })
  }

  public render() {
    const {
      error,
      error: { message }
    } = this.state
    const { serviceProgram, service } = this.props

    const designatedHotspotLocations = [...this.state.locations]
    const hotspotsSelectValues: ISelectOption[] = designatedHotspotLocations.map(item => ({
      label: item.name,
      value: item.id
    }))

    const selectedZone = this.state.locations.find(loc => loc.id === this.state.selectedHotspotZone)

    const defaultValue = this.getDefaultHotspot(selectedZone, designatedHotspotLocations)
    let selectDefaultValue
    if (selectedZone) {
      selectDefaultValue = {
        label: selectedZone.name,
        value: selectedZone.id
      }
    } else if (defaultValue !== null) {
      selectDefaultValue = {
        label: defaultValue.name,
        value: defaultValue.id
      }
    } else {
      selectDefaultValue = null
    }

    return (
      <>
        {message && <ErrorBar error={error} />}
        <div className='flex justify-end m2 '>
          <div className='col-3'>
            <div>
              <label htmlFor=''>Select Zone</label>
            </div>
            <div>
              <Select
                name='serviceLevel'
                value={selectDefaultValue}
                onChange={this.onChangeSelectHotspotZone}
                options={hotspotsSelectValues}
              />
            </div>
          </div>
        </div>

        <div className='ml3'>
          <div className='flex'>
            <div className='col-3'>
              <span className='h5 font-grey2'>{UIMessages.common.nameLabel}</span>
            </div>

            <div className='col-3'>
              <span className='h5 font-grey2'>{UIMessages.common.address}</span>
            </div>

            <div className='col-4'>
              <span className='h5 font-grey2'>{UIMessages.common.pin}</span>
            </div>
            <div className='col-2'>&nbsp; </div>
          </div>

          <div>
            <div className='bt-light-grey4'>&nbsp;</div>
          </div>
          {defaultValue &&
            defaultValue.hotspots &&
            defaultValue.hotspots.map((hotspot: IHotspot, i: number) => (
              <div className='flex mb1' key={`hotspot-${i}`}>
                <div className='col-2 mr1'>
                  <input
                    className='p1 mr3'
                    style={{
                      marginTop: 'auto',
                      marginBottom: 'auto'
                    }}
                    type='text'
                    value={hotspot.name}
                    readOnly={true}
                  />
                </div>

                <div className='col-3 mr1'>
                  <div className='flex flex-row relative'>
                    <input
                      className='p1'
                      style={{
                        marginTop: 'auto',
                        marginBottom: 'auto'
                      }}
                      type='text'
                      value={hotspot.fullAddress}
                      readOnly={true}
                    />
                  </div>
                </div>

                <div className='col-4'>
                  <div className='flex flex-row relative'>
                    <input
                      className='p1 mr3'
                      type='text'
                      style={{
                        marginTop: 'auto',
                        marginBottom: 'auto'
                      }}
                      value={`${hotspot.coordinates.lat},${hotspot.coordinates.lng}`}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </>
    )
  }

  private getDefaultHotspot(
    selected: IServiceDesignatedHotspot | undefined,
    designatedHotspotLocations: IServiceDesignatedHotspot[]
  ) {
    if (selected) {
      return selected
    }
    if (designatedHotspotLocations.length > 0) {
      return designatedHotspotLocations[0]
    } else {
      return null
    }
  }
  private onChangeSelectHotspotZone = (evt: any) => {
    if (evt && evt.value) {
      this.setState({
        selectedHotspotZone: evt.value
      })
    }
  }
}

export default ServiceViewDesignatedHotspot



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewDesignatedHotspot.tsx